export const WS_HEARTBEAT_INTERVAL_MS = 30_000;
/** A socket that misses this many heartbeats is considered dead. */
export const WS_MISSED_HEARTBEAT_LIMIT = 2;
//# sourceMappingURL=ws.js.map